<template>
  <div class="content home-body">
    <div class="row content-body">
      <div class="col-lg-12 col-md-12 col-sm-12 text-center">
        <img :src="logo" class="logo" />
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 my-4">
        <div class="mt-54">
          <h1 class="title">{{ $t("home_connect.title") }}</h1>
          <p class="slogan">{{ $t("home_connect.slogan") }}</p>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 my-4">
        <div class="d-flex gap-4 cards-login">
          <div class="card-box px-0">
            <div class="card-login text-center">
              <div class="icon-wrapper mb-2">
                <router-link to="/login-veterinaire" class="d-block">
                  <img :src="icon1"  />
                </router-link>
                <label class="title text-center">{{ $t("home_connect.vet") }}</label>
              </div>
            </div>
          </div>
          <div class="card-box px-0">
            <div class="card-login text-center">
              <div class="icon-wrapper mb-2">
                <router-link to="/login-proprietaire" class="d-block">
                  <img :src="icon2"  />
                </router-link>
                <label class="title text-center">{{ $t("home_connect.owner") }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import icon1 from "@/assets/images/doctor.svg";
  import icon2 from "../assets/images/animaux.svg";
  import logo from "../assets/images/2_LOGO - COULEURS-bg-b.png";
  import bg from "../assets/images/rectangle.png";
  export default {
    name: "AppHeader",
    data() {
      return {
        icon1,
        icon2,
        logo,
        bg,
      };
    },
  };
</script>
<style scoped>
  .home-body {
    position: relative;
    height: 100%;
  }

  .content-body .logo {
    width: 244px;
    height: 51px;
  }
  .home-body .title {
    color: #1e347d;
    font-size: 22px;
    font-weight: bold;
    text-align: center;
    line-height: 29px;
  }
  .home-body .slogan {
    font-size: 17px;
    color: #1e347d;
    text-align: center;
  }
  .cards-login {
    justify-content: center;
  }
  .home-body .icon-wrapper a {
    background: #fff;
    text-align: center;
    padding: 50px 30px;
    border: 2px solid #1e347d;
    border-radius: 10px;
    margin-bottom: 15px;
    transition: 0.2s linear;
  }
  .home-body .icon-wrapper a:hover {
    background: #c9cfde;
  }
  .card-login .title {
    color: #1e347d;
    font-size: 20px;
    line-height: 24px;
    font-weight: bold;
  }
  .home-body .icon-wrapper {
    margin: 0 auto;
  }
</style>
